import { Component, input, output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IntegrationCardData } from '@/home/settings/integrations/integration-card/integration-card.types';
import { CardModule } from 'primeng/card';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { IntegrationHelper } from '@/home/settings/integrations/integration-services/integration-helper';

@Component({
    selector: 'app-integration-card',
    standalone: true,
    imports: [TranslatePipe, CardModule, Tag, Tooltip],
    templateUrl: './integration-card.component.html',
    styleUrls: ['./integration-card.component.scss'],
})
export class IntegrationCardComponent implements OnInit, OnChanges {
    integration = input.required<IntegrationCardData>();
    cardClick = output<string>();
    i18nPrefix: string = '';

    public constructor() {}

    public ngOnInit(): void {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['integration']) {
            const integration = changes['integration'].currentValue as IntegrationCardData;
            this.i18nPrefix = IntegrationHelper.getI18nPrefix(integration);
        }
    }

    public openCard(): void {
        this.cardClick.emit(this.integration().serviceId);
    }
}
